import { Button, Divider, Tooltip } from 'antd'
import classNames from 'classnames'
import styles from '../index.module.less'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { getUCenterAppDetailByCode } from '@/services'
import { getFileUrlPrefix } from 'shj-utils'
import { BlockOutlined } from '@ant-design/icons'
import useGlobalStore from '@/store'
import { useShallow } from 'zustand/react/shallow'
import { useSetState } from 'ahooks'
import useNavigateMicro from '@/hooks/useNavigateMicro.ts'
import { getImageUrl } from '@/utils/image.ts'

const AppDetail = () => {
  const { code } = useParams()
  const navigate = useNavigate()
  const baseFile = getFileUrlPrefix()
  const [appInfo, setAppInfo] = useState<any>({})

  const [state, setState] = useSetState({
    btnDisabled: true,
  })

  const [navigateMicroPage] = useNavigateMicro()

  const { globalMenu } = useGlobalStore(
    useShallow((state: any) => ({
      globalMenu: state.menu,
    }))
  )

  useEffect(() => {
    if (globalMenu.length) {
      setState({
        btnDisabled: !globalMenu.find(d => d.key === code),
      })
    }
  }, [globalMenu])

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = () => {
    getUCenterAppDetailByCode(code).then(res => {
      setAppInfo(res || {})
    })
  }

  const openApp = () => {
    const menuItem = globalMenu.find(item => item.code === code)
    navigateMicroPage(appInfo, menuItem)
  }

  return (
    <div className={styles.app_detail}>
      <div className={styles.flex_between}>
        <div className={classNames([styles.flex_start])}>
          <div className={classNames([styles.icon, !appInfo.icon && styles.no_icon])}>
            {appInfo.icon ? (
              <img src={getImageUrl(appInfo.icon, baseFile)} />
            ) : (
              <BlockOutlined className={styles.app_icon} />
            )}
          </div>
          <div className={styles.title_wrap}>
            <p className={classNames([styles.title, styles.ellipsis])}>{appInfo.name}</p>
            <Tooltip title={appInfo.briefIntroduce}>
              <p className={classNames([styles.desc, styles.ellipsis])}>{appInfo.briefIntroduce}</p>
            </Tooltip>
          </div>
        </div>
        <div className={classNames([styles.btns])}>
          {/*<Button>申请使用</Button>*/}
          <Button
            type={'primary'}
            className={styles.ml_10}
            onClick={openApp}
            disabled={state.btnDisabled}
          >
            打开应用
          </Button>
        </div>
      </div>
      <Divider />
      <div>
        <div>
          <span className={styles.detail_desc_title}>介绍</span>
        </div>
        <p className={classNames([styles.mt_20, styles.detail_desc])}>{appInfo.introduce}</p>
      </div>
    </div>
  )
}

export default AppDetail
